// src/pages/CheckoutPage.js
import React, { useState, useEffect } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import countryList from '../countryList';

const CheckoutPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [message, setMessage] = useState('');
  const [shippingAddress, setShippingAddress] = useState({
    fullName: '',
    street: '',
    city: '',
    province: '',
    zip: '',
    country: 'Italia',
  });

  // Parametri Nexi
  const [nexiParams, setNexiParams] = useState(null);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get('cart', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCartItems(response.data.items || []);
      } catch (err) {
        console.error(err);
        setMessage('Failed to load cart.');
      }
    };
    fetchCart();
  }, []);

  // Genera e invia la form Nexi al cambiare di nexiParams
  useEffect(() => {
    if (!nexiParams) return;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = nexiParams.requestUrl; 
    for (const [key, value] of Object.entries(nexiParams)) {
      if (key === 'requestUrl') continue;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
  }, [nexiParams]);

  // Invia dati checkout e genera transazione Nexi
  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const { data } = await api.post(
        'nexi/create-payment',
        { shippingAddress },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNexiParams(data);
    } catch (error) {
      console.error('Error initiating Nexi payment:', error);
      setMessage(error.response?.data?.message || 'Payment initiation failed');
    }
  };

  // Calcolo totali
  const total = cartItems.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  const shippingCost = parseFloat(process.env.REACT_APP_SHIPPING_COST) || 0;
  const grandTotal = total + shippingCost;

  return (
    <div className="container mt-5">
      <h2 className="text-success mb-4">Checkout</h2>

      {message && <div className="alert alert-primary text-center">{message}</div>}

      {/* Riepilogo Carrello */}
      <ul className="list-group mb-4">
        {cartItems.map((item) => (
          <li className="list-group-item d-flex align-items-center" key={item.product._id}>
            <img
              src={
                item.product.images?.[0]
                  ? `https://api.iovendosiciliano.it/${item.product.images[0]}`
                  : 'https://via.placeholder.com/60'
              }
              alt={item.product.name}
              className="me-3"
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
            />
            <div className="flex-grow-1">
              <strong>{item.product.name}</strong> (x{item.quantity})
            </div>
            <div>€{(item.product.price * item.quantity).toFixed(2)}</div>
          </li>
        ))}
        <li className="list-group-item d-flex justify-content-between">
          <span>Spedizione</span>
          <strong>€{shippingCost.toFixed(2)}</strong>
        </li>
        <li className="list-group-item d-flex justify-content-between">
          <strong>Totale</strong>
          <strong>€{grandTotal.toFixed(2)}</strong>
        </li>
      </ul>

      {/* Form Indirizzo Spedizione */}
      <form onSubmit={handleOrderSubmit}>
        <h5 className="fw-bold mb-3">Shipping Address</h5>
        {['fullName', 'street', 'city', 'province', 'zip'].map((field) => (
          <div className="mb-3" key={field}>
            <label htmlFor={field} className="form-label fw-semibold">
              {field.charAt(0).toUpperCase() + field.slice(1)}
            </label>
            <input
              type="text"
              className="form-control"
              id={field}
              value={shippingAddress[field]}
              onChange={(e) =>
                setShippingAddress({ ...shippingAddress, [field]: e.target.value })
              }
              required
            />
          </div>
        ))}

        <div className="mb-3">
          <label htmlFor="country" className="form-label fw-semibold">
            Country
          </label>
          <select
            className="form-control"
            id="country"
            value={shippingAddress.country}
            onChange={(e) =>
              setShippingAddress({ ...shippingAddress, country: e.target.value })
            }
            required
          >
            {countryList.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        <button className="btn btn-success w-100 fw-bold" type="submit">
          Place Order
        </button>
      </form>
    </div>
  );
};

export default CheckoutPage;
